import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type State = {
  dataCustomerCare: any;
  lichSus: any;
  idCustomerCare: number | string;
  idDatlichPT: string | number;
  checkedRow: any;
};

const initialState: State = {
  idCustomerCare: null,
  dataCustomerCare: null,
  lichSus: null,
  idDatlichPT: null,
  checkedRow: null,
};

export const consultantAndFragmentSlice = createSlice({
  name: "consultantAndFragment",
  initialState: initialState,
  reducers: {
    setIdCustomerCare: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idCustomerCare: actions.payload,
      };
    },
    setDataCustomerCare: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        dataCustomerCare: actions.payload,
      };
    },
    setDataLichSus: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        lichSus: actions.payload,
      };
    },
    setIdDatLich: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idDatlichPT: actions.payload,
      };
    },
    setCheckedRow: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        checkedRow: actions.payload,
      };
    },
  },
});

export const {
  setIdCustomerCare,
  setIdDatLich,
  setDataCustomerCare,
  setDataLichSus,
  setCheckedRow,
} = consultantAndFragmentSlice.actions;
export default consultantAndFragmentSlice.reducer;
